import { css } from 'emotion';
import { variables } from './variables';
import { SpatialOption, space } from '@joykit/variables/space';
import { ColumnsProps } from '.';

export namespace styles {
  const containerOffset = (columnGap: SpatialOption) =>
    css(
      {
        marginLeft: `-${space.values.toRem.default}`,
        marginRight: `-${space.values.toRem.default}`,
        marginTop: `-${space.values.toRem.default}`
      },
      columnGap !== 'default'
        ? {
            // Container offset overrides
            marginLeft: `-${space.values.toRem[columnGap]}`,
            marginRight: `-${space.values.toRem[columnGap]}`
          }
        : undefined
    );

  const columnLayout = (columnGap: SpatialOption) => {
    return css(
      {
        // Establish the default column padding
        padding: space.values.toRem.default
      },
      columnGap !== 'default'
        ? {
            // Gutter overrides
            paddingLeft: space.values.toRem[columnGap],
            paddingRight: space.values.toRem[columnGap]
          }
        : undefined
    );
  };

  export const container = ({ columnGap, multiline, centered, stackOnMobile }: ColumnsProps) => {
    return css(containerOffset(columnGap), {
      flexWrap: multiline ? 'wrap' : undefined,
      justifyContent: centered ? 'center' : undefined,
      display: stackOnMobile ? 'flex' : undefined,
      ':not(:last-child)': {
        marginBottom: `calc((${space.values.toRem.default} * 2)  - ${space.values.toRem.default})`
      },
      // Column Spacing
      // We target the direct children that are a `Column`.
      [` > .${variables.COLUMN_CLASS_NAME}`]: columnLayout(columnGap),

      [`@media(min-width: ${variables.breakpointsByScreen.tablet}px)`]: {
        display: 'flex'
      }
    });
  };
}
